import {HttpClient} from '@angular/common/http';
import {ToastService} from '../../toast-service';
import {Injectable} from "@angular/core";
import {BatchUpdateRequest} from "../../../model/api/batch-update-request";
import {Observable} from "rxjs";
import {ApiValidation} from "../../../model/api/api-validation";
import {Clearing} from "../../../model/clearing/clearing";
import {CrystalclearSupportBackUrl} from "../../config/crystalclear-support-back-url";
import {CommonCrudService} from "../../common/common-crud.service";

@Injectable({
  providedIn: 'root'
})
export class SupportClearingService extends CommonCrudService<Clearing> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearSupportBackUrl.GET_SUPPORT_CLEARING_LIST,
      CrystalclearSupportBackUrl.SAVE_SUPPORT_CLEARING,
      CrystalclearSupportBackUrl.DELETE_SUPPORT_CLEARING);
  }

  public saveBatch(request: BatchUpdateRequest<Clearing>): Observable<ApiValidation<any>> {
    return this.post(CrystalclearSupportBackUrl.SAVE_BATCH_SUPPORT_CLEARING, request);
  }

}
